import React, { Component } from 'react';
import { connect } from 'react-redux';
import Actions from '~/Actions';
import Actions_Wind from '~/Actions_Wind';
import permission from '~/skills/permission';
import * as getTime from '~/skills/getTime';
import * as getStatus from '~/skills/getStatus';
import PageTitle from '~/components/PageTitle';
import SearchBar from '~/components/SearchBar';
import { EAA_Item, EAA_ItemContainer, EAA_Input, EAA_Select, EAA_ErrorText, EAA_Row, EAA_TitleText, EAA_Date, EAA_Upload, EAA_Btn, EAA_ExcelDownload, EAA_Status, EAA_UpdateTime, EAA_BottomBtn } from '~/components/EditAndAddItem';
import AddRes from '~/components/Dialog/AddRes';
import EditRes from '~/components/Dialog/EditRes';
import Sub1 from './Sub1';
import Sub2 from './Sub2';
import Sub3 from './Sub3';

const returnAryName = ({ ary = [], value = '' }) => {
  for (const o of ary) {
    if (o.value === value) return o.name;
  }
};

class Page_Contract extends Component {
  state={ data: {}, old_data: {}, mode: '', errorAry: [], canSend: true }

  componentDidMount () {
    const { getBaseData } = this.props;
    getBaseData();
  }

  componentDidUpdate (preProps) {
    const { AContractData: preAContractData = {} } = preProps;
    const { AContractData = {}, mode } = this.props;
    if (Object.keys(preAContractData).length === 0 && Object.keys(AContractData).length > 0 && (mode !== 'add')) {
      this.setState({ data: AContractData, old_data: JSON.parse(JSON.stringify(AContractData)) });
    }
  }

  componentWillUnmount () {
    this.props.clearKey('AContractData');
  }

  changeData=({ label = '', data = '' }, func = () => {}) => {
    const { data: body } = this.state;
    const newBody = {
      ...body,
      [label]: data,
    };
    this.setState({ data: newBody }, func);
  }

  goToCheck=() => this.setState({ mode: 'check' }, () => this.filterError())
  goToEdit=() => this.setState({ mode: '', errorAry: [] });
  getSendBody=() => {
    const { data } = this.state;
    const body = {
      sign_contract_date: data.sign_contract_date || '',
      sign_upload_files: data.sign_upload_files || [],
      bid_item: data.bid_item || '',
      change_protocol_date: data.change_protocol_date || '',
      content_note: data.content_note || '',
      protocol_upload_files: data.protocol_upload_files || [],
      change_protocol_upload_files: data.change_protocol_upload_files || [],
      applicant: data.applicant || '',
      company_type: data.company_type || '',
      company_register_date: data.company_register_date || '',
      site_name: data.site_name || '',
      site_num: data.site_num || '',
      shore_distance: data.shore_distance || '',
      water_depth_start: data.water_depth_start || '',
      water_depth_end: data.water_depth_end || '',
      site_area: data.site_area || '',
      site_upload_imgs: data.site_upload_imgs || [],
      site_upload_files: data.site_upload_files || [],
      set_total_capacity_start: data.set_total_capacity_start || '',
      set_total_capacity_end: data.set_total_capacity_end || '',
      conn_point: data.conn_point || '',
      obtain_setup_permiss_date: data.obtain_setup_permiss_date || '',
      obtain_construction_permiss_date: data.obtain_construction_permiss_date || '',
      permiss_date: data.permiss_date || '',
      capacity_allocation_year: data.capacity_allocation_year || '',
      commit_completion_date: data.commit_completion_date || '',
      commit_provide_date: data.commit_provide_date || '',
      public_date: data.public_date || '',
      public_number: data.public_number || '',
      performance_upload_files: data.performance_upload_files || [],
      performance_price: data.performance_price || '',

      sub1: data.sub1 || [],
      sub2: data.sub2 || [],
      sub3: data.sub3 || [],

      contract_status: data.contract_status || '0',

      windcontract_id: Actions_Wind.wind_id(),
    };
    return body;
  }

  add=(status = {}) => {
    this.setState({ canSend: false });
    const { postAddNewAContractData } = this.props;
    const body = { ...this.getSendBody(), ...status };
    postAddNewAContractData(body);
  }

  edit=(status = {}) => {
    this.setState({ canSend: false });
    const { putAContractData } = this.props;
    const body = { ...this.getSendBody(), ...status };
    putAContractData(this.state.data.id, body);
  }

  _onClose=() => {
    const { clearKey, getAContractData } = this.props;
    clearKey('AContractData');
    getAContractData();
    this.setState({ canSend: true, mode: '' });
  }

  filterError=() => {
    const { ACompanyTypeList = [] } = this.props;
    const { data = {} } = this.state;
    const changed = data.contract_status > 0;
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const errorAry = [
      returnInputValue(data.sign_contract_date) === '', // 0 簽訂行政契約日期
      (data.sign_upload_files || []).length === 0, // 1 簽訂行政契約函文
      changed && returnInputValue(data.change_protocol_date) === '', // 2 換約/變更議定書日期
      changed && returnInputValue(data.content_note) === '', // 3 內容說明
      changed && (data.protocol_upload_files || []).length === 0, // 4 議定書
      changed && (data.change_protocol_upload_files || []).length === 0, // 5 換約/變更同意函文
      returnInputValue(data.applicant) === '', // 6 申請人
      (returnAryName({ ary: ACompanyTypeList, value: data.company_type }) === '公司') && (returnInputValue(data.company_register_date) === ''), // 7 公司登記日期(選擇公司)
      returnInputValue(data.site_name) === '', // 8 場址名稱
      returnInputValue(data.shore_distance) === '', // 9 岸距
      returnInputValue(data.water_depth_start) === '', // 10 水深 - 最淺
      returnInputValue(data.water_depth_end) === '', // 11 水深 - 最深
      (!(returnInputValue(data.water_depth_start) === '')) && (!(returnInputValue(data.water_depth_end) === '')) && (data.water_depth_start > data.water_depth_end), // 12 (水深 - 最淺) 大於 (水深 - 最深)
      returnInputValue(data.site_area) === '', // 13 場址面積
      (data.site_upload_imgs || []).length === 0, // 14 場址邊界 - 上傳示意圖
      (data.site_upload_files || []).length === 0, // 15 場址邊界 - 上傳座標 Excel 檔案
      returnInputValue(data.set_total_capacity_start) === '', // 16 設置總容量 - 起
      returnInputValue(data.set_total_capacity_end) === '', // 17 設置總容量 - 迄
      (!(returnInputValue(data.set_total_capacity_start) === '')) && (!(returnInputValue(data.set_total_capacity_end) === '')) && (data.set_total_capacity_start > data.set_total_capacity_end), // 18 (設置總容量 - 起) 大於 (設置總容量 - 迄)
      returnInputValue(data.conn_point) === '', // 19 併接點位
      returnInputValue(data.obtain_setup_permiss_date) === '', // 20 應取得籌設許可時程
      returnInputValue(data.obtain_construction_permiss_date) === '', // 21 應取得施工許可時程
      returnInputValue(data.capacity_allocation_year) === '', // 22 容量獲配年度
      returnInputValue(data.commit_completion_date) === '', // 23 承諾完工併聯/商轉時程
      returnInputValue(data.commit_provide_date) === '', // 24 承諾提出具體產業關聯方案、佐證資料及產發署意見函時程
      returnInputValue(data.public_date) === '', // 25 發文日期
      returnInputValue(data.public_number) === '', // 26 發文文號
      (data.performance_upload_files || []).length === 0, // 27 履約函上傳
      returnInputValue(data.performance_price) === '', // 28 履約保證金金額
    ];
    this.setState({ errorAry });
    return errorAry.indexOf(true) !== -1;
  }

  render () {
    const { ACompanyTypeList = [], WMGroupList = [], AConnPointList = [], canEdit } = this.props;
    const { data, old_data, mode, errorAry, canSend } = this.state;
    const isCheck = mode === 'check';
    const disabled = isCheck || !canEdit || (!getStatus.canEdit(data));
    const returnInputValue = t => typeof (t) !== ('undefined') && typeof (t) !== ('object') ? t : '';
    const checkChange = label => isCheck ? (data[label] || '') !== (old_data[label] || '') : false;
    const checkFilesChange = label => isCheck ? JSON.stringify(data[label] || []) !== JSON.stringify(old_data[label] || []) : false;
    const checkSubChange = (n, ary = []) => isCheck ? JSON.stringify(data[`sub${n}`] || ary) !== JSON.stringify(old_data[`sub${n}`] || ary) : false;
    const allRight = errorAry.indexOf(true) === -1;
    const isAdd = Object.keys(old_data).length === 0;

    const returnForceOpen = ({ least = 0, most = 0 }) => {
      for (let i = 0; i < errorAry.length; i++) {
        if (i >= least && i <= most && errorAry[i]) return true;
      }
      return false;
    };

    const titleWidth = 170;
    const errorLeft = 20 + titleWidth;

    const getYaerAry = () => {
      const ary = [];
      let i = 109;
      while (i <= 124) {
        ary.push({ name: i, value: i.toString() });
        i++;
      }
      return ary;
    };

    const passing = getStatus.form(data) === '已通過';
    const changed = data.contract_status > 0;

    return (
      <div style={{
        position: 'absolute',
        left: 13,
        right: 0,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'start',
        overflow: 'auto',
      }}
      >
        <PageTitle text='契約內容' />
        <div style={{ minHeight: 8 }} />

        <div style={{ display: 'flex', marginTop: 22, alignItems: 'center', width: '100%' }}>
          <div style={{ fontSize: 20, fontWeight: 700, marginLeft: 50 }}>行政契約狀態</div>
          {(!data.contract_status || (data.contract_status === '0')) && <div style={{ fontSize: 20, fontWeight: 500, color: '#2F80ED', marginLeft: 50 }}>已簽訂原始契約(原始版本)</div>}
          {data.contract_status && (data.contract_status !== '0') && <div style={{ fontSize: 20, fontWeight: 500, color: '#2F80ED', marginLeft: 50 }}>{`第${data.contract_status}次變更`}</div>}
          <div style={{ flex: 1 }} />
          {passing && canEdit && (
            <EAA_Btn
              style={{
                height: 40,
                width: 154,
                backgroundColor: '#5597B4',
                marginRight: '2%',
              }}
              onClick={() => this.setState({
                data: {
                  ...data,
                  contract_status: (parseInt(data.contract_status) + 1).toString(),
                  form_status: '1',
                  admin_status: '0',
                },
              })}
            >
              行政契約變更
            </EAA_Btn>
          )}
        </div>

        <SearchBar style={{ marginTop: 8 }} defaultOpen text='行政契約資訊' forceOpen={returnForceOpen({ least: 0, most: 5 })}>
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='簽訂行政契約日期' bol haveChange={checkChange('sign_contract_date')} />
                <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.sign_contract_date)} onChange={data => { this.changeData({ label: 'sign_contract_date', data: getTime.getType3Time(data) }); }} />
              </EAA_ItemContainer>
              {errorAry[0] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
            </EAA_Item>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='簽訂行政契約函文' bol haveChange={checkFilesChange('sign_upload_files')} />
                <EAA_Upload displayBorder disabled={disabled} hint='檔案上傳' value={data.sign_upload_files || []} onChange={data => this.changeData({ label: 'sign_upload_files', data })} />
              </EAA_ItemContainer>
              {errorAry[1] && <EAA_ErrorText marginLeft={errorLeft} text='請上傳檔案' />}
            </EAA_Item>
          </EAA_Row>

          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='遴選/競價' haveChange={checkChange('bid_item')} />
                <EAA_Select displayBorder disabled={disabled} list={WMGroupList} value={returnInputValue(data.bid_item)} onChange={data => { this.changeData({ label: 'bid_item', data }); }} />
              </EAA_ItemContainer>
            </EAA_Item>
            <EAA_Item />
          </EAA_Row>

          {changed && (
            <EAA_Row>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='換約/變更議定書' subtitle='日期' subtitleColor='black' bol haveChange={checkChange('change_protocol_date')} />
                  <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.change_protocol_date)} onChange={data => { this.changeData({ label: 'change_protocol_date', data: getTime.getType3Time(data) }); }} />
                </EAA_ItemContainer>
                {errorAry[2] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
              </EAA_Item>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='內容說明' bol haveChange={checkChange('content_note')} />
                  <EAA_Input displayBorder disabled={disabled} value={returnInputValue(data.content_note)} onChange={data => { this.changeData({ label: 'content_note', data }); }} />
                </EAA_ItemContainer>
                {errorAry[3] && <EAA_ErrorText marginLeft={errorLeft} text='請說明' />}
              </EAA_Item>
            </EAA_Row>
          )}

          {changed && (
            <EAA_Row>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='議定書' bol haveChange={checkFilesChange('protocol_upload_files')} />
                  <EAA_Upload displayBorder disabled={disabled} hint='議定書上傳' value={data.protocol_upload_files || []} onChange={data => this.changeData({ label: 'protocol_upload_files', data })} />
                </EAA_ItemContainer>
                {errorAry[4] && <EAA_ErrorText marginLeft={errorLeft} text='請上傳檔案' />}
              </EAA_Item>
              <EAA_Item>
                <EAA_ItemContainer>
                  <EAA_TitleText width={titleWidth} text='換約/變更同意函文' bol haveChange={checkFilesChange('change_protocol_upload_files')} />
                  <EAA_Upload displayBorder disabled={disabled} hint='函文上傳' value={data.change_protocol_upload_files || []} onChange={data => this.changeData({ label: 'change_protocol_upload_files', data })} />
                </EAA_ItemContainer>
                {errorAry[5] && <EAA_ErrorText marginLeft={errorLeft} text='請上傳檔案' />}
              </EAA_Item>
            </EAA_Row>
          )}
        </SearchBar>

        <SearchBar style={{ marginTop: 8 }} text='行政契約乙方' forceOpen={returnForceOpen({ least: 6, most: 7 })}>
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='申請人' bol haveChange={checkChange('applicant')} />
                <EAA_Input displayBorder disabled={disabled} value={returnInputValue(data.applicant)} onChange={data => { this.changeData({ label: 'applicant', data }); }} />
              </EAA_ItemContainer>
              {errorAry[6] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入' />}
            </EAA_Item>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='籌備處/公司' haveChange={checkChange('company_type')} />
                <EAA_Select displayBorder disabled={disabled} list={ACompanyTypeList} value={returnInputValue(data.company_type)} onChange={data => { this.changeData({ label: 'company_type', data }); }} />
              </EAA_ItemContainer>
            </EAA_Item>
          </EAA_Row>

          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='公司登記日期' bol={returnAryName({ ary: ACompanyTypeList, value: data.company_type }) === '公司'} haveChange={checkChange('company_register_date')} />
                <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.company_register_date)} onChange={data => { this.changeData({ label: 'company_register_date', data: getTime.getType3Time(data) }); }} />
              </EAA_ItemContainer>
              {errorAry[7] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
            </EAA_Item>
            <EAA_Item />
          </EAA_Row>

          <Sub1 data={data} disabled={disabled} titleWidth={titleWidth} checkChange={checkChange} changeData={this.changeData} checkSubChange={checkSubChange} />

        </SearchBar>

        <SearchBar style={{ marginTop: 8 }} text='場址資訊' forceOpen={returnForceOpen({ least: 8, most: 19 })}>
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='場址名稱' bol haveChange={checkChange('site_name')} />
                <EAA_Input displayBorder disabled={disabled} value={returnInputValue(data.site_name)} onChange={data => { this.changeData({ label: 'site_name', data }); }} />
              </EAA_ItemContainer>
              {errorAry[8] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入' />}
            </EAA_Item>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='場址編號' haveChange={checkChange('site_num')} />
                <EAA_Input displayBorder disabled={disabled} value={returnInputValue(data.site_num)} hint='可多筆，逗號' onChange={data => { this.changeData({ label: 'site_num', data }); }} />
              </EAA_ItemContainer>
            </EAA_Item>
          </EAA_Row>

          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='岸距' bol haveChange={checkChange('shore_distance')} />
                <EAA_Input displayBorder disabled={disabled} type='number' unit='公里' value={returnInputValue(data.shore_distance)} onChange={data => { this.changeData({ label: 'shore_distance', data }); }} />
              </EAA_ItemContainer>
              {errorAry[9] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入' />}
            </EAA_Item>
            <EAA_Item />
          </EAA_Row>

          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='水深' bol haveChange={checkChange('water_depth_start') || checkChange('water_depth_end')} />
                <EAA_Input displayBorder marginRight={0} disabled={disabled} type='number' hint='最淺' unit='公尺' value={returnInputValue(data.water_depth_start)} onChange={data => { this.changeData({ label: 'water_depth_start', data }); }} />
                <div style={{ marginLeft: 20, marginRight: 20 }}>~</div>
                <EAA_Input displayBorder disabled={disabled} type='number' hint='最深' unit='公尺' value={returnInputValue(data.water_depth_end)} onChange={data => { this.changeData({ label: 'water_depth_end', data }); }} />
              </EAA_ItemContainer>
              {errorAry[10] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入最淺水深' />}
              {errorAry[11] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入最深水深' />}
              {errorAry[12] && <EAA_ErrorText marginLeft={errorLeft} text='『最淺水深』不可深於『最深水深』' />}
            </EAA_Item>
          </EAA_Row>

          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='場址面積' bol haveChange={checkChange('site_area')} />
                <EAA_Input displayBorder disabled={disabled} type='number' hint='小數點下兩位' unit='平方公里' value={returnInputValue(data.site_area)} onChange={data => { this.changeData({ label: 'site_area', data }); }} />
              </EAA_ItemContainer>
              {errorAry[13] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入' />}
            </EAA_Item>
            <EAA_Item />
          </EAA_Row>

          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='' haveChange={checkChange('eeeee')} />
                <div style={{ flex: 1, fontSize: 16, fontWeight: 400, color: 'rgba(0, 0, 0, 0.54)', marginRight: 12 }}>上傳示意圖</div>
                <div style={{ flex: 1, fontSize: 16, fontWeight: 400, color: 'rgba(0, 0, 0, 0.54)', marginRight: 12 }}>上傳座標 Excel 檔案</div>
                <div style={{ marginRight: 155 }} />
              </EAA_ItemContainer>
            </EAA_Item>
          </EAA_Row>
          <EAA_Row style={{ marginTop: 0 }}>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='場址邊界' bol haveChange={checkFilesChange('site_upload_imgs') || checkFilesChange('site_upload_files')} />
                <EAA_Upload displayBorder disabled={disabled} hint='上傳示意圖' value={data.site_upload_imgs || []} onChange={data => this.changeData({ label: 'site_upload_imgs', data })} marginRight={12} />
                <EAA_Upload displayBorder disabled={disabled} hint='上傳座標 Excel 檔案' value={data.site_upload_files || []} onChange={data => this.changeData({ label: 'site_upload_files', data })} marginRight={12} accept='.xlsx' />
                <div>
                  <EAA_ExcelDownload style={{ marginRight: 50 }} />
                  <div style={{ color: '#f40000', textAlign: 'start' }}>註:依契約填寫</div>
                </div>
              </EAA_ItemContainer>
            </EAA_Item>
          </EAA_Row>
          <EAA_Row style={{ marginTop: 0 }}>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} />
                <div style={{ flex: 1, marginRight: 12 }} />
                <div style={{ flex: 1, marginRight: 150, color: '#f40000', textAlign: 'start' }}>註:座標系統與格式依行政契約內容</div>
              </EAA_ItemContainer>
              {errorAry[14] && <EAA_ErrorText marginLeft={errorLeft} text='請上傳示意圖' />}
              {errorAry[15] && <EAA_ErrorText marginLeft={errorLeft} text='請上傳座標檔' />}
            </EAA_Item>
          </EAA_Row>

          <Sub2 data={data} disabled={disabled} titleWidth={titleWidth} checkChange={checkChange} changeData={this.changeData} checkSubChange={checkSubChange} />

          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='設置總容量' bol haveChange={checkChange('set_total_capacity_start') || checkChange('set_total_capacity_end')} />
                <EAA_Input displayBorder marginRight={0} disabled={disabled} type='number' hint='小數點下兩位' unit='MW' value={returnInputValue(data.set_total_capacity_start)} onChange={data => { this.changeData({ label: 'set_total_capacity_start', data }); }} />
                <div style={{ marginLeft: 20, marginRight: 20 }}>~</div>
                <EAA_Input displayBorder disabled={disabled} type='number' hint='小數點下兩位' unit='MW' value={returnInputValue(data.set_total_capacity_end)} onChange={data => { this.changeData({ label: 'set_total_capacity_end', data }); }} />
              </EAA_ItemContainer>
              <EAA_ErrorText marginLeft={errorLeft} text='註:如只有一個值，則兩格填一樣即可' />
              {errorAry[16] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入『總容量 - 起』' />}
              {errorAry[17] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入『總容量 - 迄』' />}
              {errorAry[18] && <EAA_ErrorText marginLeft={errorLeft} text='『總容量 - 起』不可大於『總容量 - 迄』' />}
            </EAA_Item>
          </EAA_Row>

          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='併接點位' bol haveChange={checkChange('conn_point')} />
                <EAA_Select displayBorder disabled={disabled} list={AConnPointList} value={returnInputValue(data.conn_point)} onChange={data => { this.changeData({ label: 'conn_point', data }); }} />
              </EAA_ItemContainer>
              {errorAry[19] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇' />}
            </EAA_Item>
            <EAA_Item />
          </EAA_Row>
        </SearchBar>

        <SearchBar style={{ marginTop: 8 }} text='契約時程' forceOpen={returnForceOpen({ least: 20, most: 24 })}>
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='應取得籌設許可時程' bol haveChange={checkChange('obtain_setup_permiss_date')} />
                <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.obtain_setup_permiss_date)} onChange={data => { this.changeData({ label: 'obtain_setup_permiss_date', data: getTime.getType3Time(data) }); }} />
              </EAA_ItemContainer>
              {errorAry[20] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
            </EAA_Item>
            <EAA_Item />
          </EAA_Row>

          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='應取得施工許可時程' bol haveChange={checkChange('obtain_construction_permiss_date')} />
                <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.obtain_construction_permiss_date)} onChange={data => { this.changeData({ label: 'obtain_construction_permiss_date', data: getTime.getType3Time(data) }); }} />
              </EAA_ItemContainer>
              {errorAry[21] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
            </EAA_Item>
            <EAA_Item />
          </EAA_Row>

          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='承諾「全部遴選獲配容' titleAry={[{ title: '量百分之五十完工併聯', color: 'black' }, { title: '」或「所有風力機組水', color: 'black' }, { title: '下基礎設置」時程', color: 'black' }]} haveChange={checkChange('permiss_date')} />
                <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.permiss_date)} onChange={data => { this.changeData({ label: 'permiss_date', data: getTime.getType3Time(data) }); }} />
              </EAA_ItemContainer>
            </EAA_Item>
            <EAA_Item />
          </EAA_Row>

          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='容量獲配年度' bol haveChange={checkChange('capacity_allocation_year')} />
                <EAA_Select displayBorder disabled={disabled} label='民國' unit='年' list={getYaerAry()} value={returnInputValue(data.capacity_allocation_year)} onChange={data => { this.changeData({ label: 'capacity_allocation_year', data }); }} />
              </EAA_ItemContainer>
              {errorAry[22] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇' />}
            </EAA_Item>
            <EAA_Item />
          </EAA_Row>

          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='承諾完工併聯/商轉' subtitle='時程' subtitleColor='black' bol haveChange={checkChange('commit_completion_date')} />
                <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.commit_completion_date)} onChange={data => { this.changeData({ label: 'commit_completion_date', data: getTime.getType3Time(data) }); }} />
              </EAA_ItemContainer>
              {errorAry[23] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
            </EAA_Item>
            <EAA_Item />
          </EAA_Row>

          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='承諾提出具體產業關' titleAry={[{ title: '聯方案、佐證資料及', color: 'black' }, { title: '產發署意見函時程', color: 'black' }]} bol haveChange={checkChange('commit_provide_date')} />
                <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.commit_provide_date)} onChange={data => { this.changeData({ label: 'commit_provide_date', data: getTime.getType3Time(data) }); }} />
              </EAA_ItemContainer>
              {errorAry[24] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
            </EAA_Item>
            <EAA_Item />
          </EAA_Row>
        </SearchBar>

        <SearchBar style={{ marginTop: 8 }} text='履約保證函相關內容' forceOpen={returnForceOpen({ least: 25, most: 28 })}>
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='發文日期' bol haveChange={checkChange('public_date')} />
                <EAA_Date displayBorder disabled={disabled} value={getTime.returnDate(data.public_date)} onChange={data => { this.changeData({ label: 'public_date', data: getTime.getType3Time(data) }); }} />
              </EAA_ItemContainer>
              {errorAry[25] && <EAA_ErrorText marginLeft={errorLeft} text='請選擇日期' />}
            </EAA_Item>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='發文文號' bol haveChange={checkChange('public_number')} />
                <EAA_Input displayBorder disabled={disabled} value={returnInputValue(data.public_number)} onChange={data => { this.changeData({ label: 'public_number', data }); }} />
              </EAA_ItemContainer>
              {errorAry[26] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入' />}
            </EAA_Item>
          </EAA_Row>
          <EAA_Row>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='履約函上傳' bol haveChange={checkFilesChange('performance_upload_files')} />
                <EAA_Upload displayBorder disabled={disabled} value={data.performance_upload_files || []} onChange={data => this.changeData({ label: 'performance_upload_files', data })} />
              </EAA_ItemContainer>
              {errorAry[27] && <EAA_ErrorText marginLeft={errorLeft} text='請上傳檔案' />}
            </EAA_Item>
            <EAA_Item>
              <EAA_ItemContainer>
                <EAA_TitleText width={titleWidth} text='履約保證金金額' bol haveChange={checkChange('performance_price')} />
                <EAA_Input displayBorder disabled={disabled} type='number' label='新台幣' unit='元整' value={returnInputValue(data.performance_price)} onChange={data => { this.changeData({ label: 'performance_price', data }); }} />
              </EAA_ItemContainer>
              {errorAry[28] && <EAA_ErrorText marginLeft={errorLeft} text='請輸入金額' />}
            </EAA_Item>
          </EAA_Row>

          <Sub3 data={data} disabled={disabled} titleWidth={titleWidth} checkChange={checkChange} changeData={this.changeData} checkSubChange={checkSubChange} />

        </SearchBar>

        <div style={{ height: 16 }} />

        <EAA_Status data={data} />
        <EAA_UpdateTime data={data} />

        <EAA_BottomBtn
          disGoBack
          {...{
            data,
            mode: canEdit ? (isAdd ? 'add' : 'edit') : 'view',
            isCheck,
            allRight,
            canSend,
            onClose: this._onClose,
            goToCheck: this.goToCheck,
            goToEdit: this.goToEdit,
            add: this.add,
            edit: this.edit,
          }}
        />
        <AddRes sucFunc={this._onClose} failFunc={() => this.setState({ canSend: true })} resKey='PostAddNewAContractData' />
        <EditRes sucFunc={this._onClose} failFunc={() => this.setState({ canSend: true })} resKey='PutAContractData' />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  ACompanyTypeList: state.data.ACompanyTypeList,
  WMGroupList: state.data.WMGroupList,
  AConnPointList: state.data.AConnPointList,
  AContractData: state.data.AContractData,
  ...permission.returnPermission(state),
});
const mapDispatchToProps = dispatch => ({
  clearKey: key => Actions.clearKey(dispatch, { key }),
  getBaseData: () => {
    Actions_Wind.getACompanyTypeList(dispatch);
    // Actions_Wind.getABidItemList(dispatch);
    Actions_Wind.getWMGroupList(dispatch);
    Actions_Wind.getAConnPointList(dispatch);
    Actions_Wind.getAContractData(dispatch);
    Actions_Wind.getACDefaultList(dispatch);
  },
  getAContractData: () => Actions_Wind.getAContractData(dispatch),
  postAddNewAContractData: body => Actions_Wind.postAddNewAContractData(dispatch, { body }),
  putAContractData: (id, body) => Actions_Wind.putAContractData(dispatch, { id, body }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Page_Contract);
